import { useOutletContext } from "react-router-dom";
import type { State } from "../../EnterpriseHub";
import { Box, SimpleGrid, Text } from "@mantine/core";
import type { ProductSections } from "../../../lib/productSections";
import { ProductBlock } from "../../../components/ProductBlock";

export function AdminOnlyScenario() {
  const { sections } = useOutletContext<{ state: State; sections: ProductSections }>();

  return sections ? (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
      {[...sections.active, ...sections.available].map(([product, e]) => (
        <ProductBlock
          key={product.key}
          product={product}
          entitlement={e}
          isLocked={true}
          ctaLabel="No entitlement"
          badge={{
            title: 'LOCKED',
            color: 'var(--text-subtle)',
          }}
        />
      ))}
    </SimpleGrid>
  ) : <NoProductsPanel />;
}



function NoProductsPanel() {
  return (
    <Box bg={'var(--bg-surface)'} p={'lg'} bdrs={'md'} bd={'1px solid var(--border-default)'} >
      <Text size="md" c={'var(--text-subtle)'}>
        No Cloudhouse products are configured for your organisation yet. Talk to your account manager to get started.
      </Text>
    </Box>
  );
}
